<div id="host">
  <h2>{{'menu-attestations' | translate}}</h2>
  <div class="filters d-flex flex-wrap">
    <app-datepicker style="margin-left: 2%" [stampdebut]="filtersActive().from" [stampfin]="filtersActive().to"
      [attestation]="true" (myDatePicker)="searchByTimestamp($event)">
    </app-datepicker>
    <app-filters-ba [defaultFilter]="filtersActive()" [promiseResult]="promiseResult" (applyFilter)="searchRequestFilters($event)">
    </app-filters-ba>
    <button (click)="resetAll()" type="button" class="reset"></button>
  </div>
  @if (awaitChargementListe() && !loadingOerror()) {
    <div class="d-flex flex-row canv align-items-start">
      <div class="flex-grow-0 canevasListe d-flex flex-column" id="canevasListe">
        <div class="d-flex justify-content-between flex-row">
          @if (!searchmodel() && filtersActive().from && filtersActive().to) {
            <h3>
              {{'attestations-title-h2' | translate}}
              {{titrefiltreDate(filtersActive().from ?? 0, filtersActive().to ?? 0).toLowerCase()}}
            </h3>
            <h3 class="datetotitle">
              {{timestampToDate(filtersActive().from)}}
              - {{timestampToDate(filtersActive().to)}}
            </h3>
          }
          @if (searchmodel() && searchmodel().length < 30) {
            <h3>
              {{'attestations-title-search-h2' | translate}} {{searchmodel()}}
            </h3>
          } @else {
            @if (searchmodel() && searchmodel().length > 30) {
              <h3 placement="top" [ngbTooltip]="searchmodel()">
                {{'attestations-title-search-h2' | translate}} {{formatId(searchmodel())}}
              </h3>
            }
          }
          @if (searchmodel() && listBorn()) {
            <h3 class="datetotitle">
              {{timestampToDate(listBorn()[listBorn().length - 1].createdAt)}}
              - {{timestampToDate(listBorn()[0].createdAt)}}
            </h3>
          }
        </div>
        <div class="d-flex flex-wrap justify-content-center">
          <h4 class="result">{{promiseResult?.totalNbRows}} {{'results' | translate}}</h4>
        </div>
        @if (promiseResult && awaitChargementListe()) {
          <ngb-pagination [page]="page()" [maxSize]="4"
            [pageSize]="pageSize()" [collectionSize]="promiseResult.totalNbRows" [rotate]="true" [ellipses]="false"
            [boundaryLinks]="true" (pageChange)="changePage($event)">
          </ngb-pagination>
        }
        @if (listBorn()) {
          <ul>
            @for (attestation of listBorn() | existingReports; track attestation) {
              <li class="d-flex flex-row elem"
                [class.actif]="attestation === selectedBrowserAttestation()"
                (click)="setBrowserAttestation(attestation);scrollTo()">
                <div class="d-flex flex-column appAndId">
                  @if (attestation.appInfo?.appName) {
                    <h4 class="elemTitre" (window:resize)="majFormID($event, attestation.appInfo.appName)">
                      {{formatAPPName(attestation.appInfo.appName) | capitalizeWords}}
                    </h4>
                  }
                  <p class="text-center" (window:resize)="majFormID($event, attestation.id)">
                    {{formatId(attestation.id)}}
                  </p>
                </div>
                <hr class="elemListehr">
                <div class="d-flex flex-column justify-content-center align-items-center os">
                  <img class="osIcon"
                    src="assets/icons/logosOS/{{attestation.deviceInfo.osName.toLowerCase()}}.svg">
                  <h4 class="elemTitre">{{attestation.deviceInfo.osVersion}}</h4>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center browser">
                  <img class="browserIcon"
                    [src]="'assets/icons/BrowserAttestations/browsers/' + (attestation.deviceInfo.browserName.toLowerCase() | browser) + '.svg'">
                  <h4 class="elemTitre">{{attestation.deviceInfo.browserMajorVersion}}</h4>
                </div>
                <div class="d-flex flex-column date">
                  <h4 class="elemTitre">{{titrefiltreDate(attestation.createdAt, today())}}</h4>
                  <h5>
                    {{timestampToDate(attestation.createdAt)}}
                    <h6>{{getHoraire(attestation.createdAt)}}</h6>
                  </h5>
                </div>
                <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
              </li>
            }
          </ul>
        }
        @if (promiseResult && awaitChargementListe()) {
          <ngb-pagination [page]="page()" [maxSize]="4"
            [pageSize]="pageSize()" (pageChange)="changePage($event)" [collectionSize]="promiseResult.totalNbRows"
            [rotate]="true" [ellipses]="false" [boundaryLinks]="true">
          </ngb-pagination>
        }
        @if (selectedBrowserAttestation()) {
          <div class="flex-grow-0" id="detailsBrowser">
            @if (selectedBrowserAttestation()?.id) {
              <h3 class="d-flex flex-row justify-content-center">
                {{'compromise-reports-title-details' | translate}}
                <h3 type="button" placement="top" [ngbTooltip]="selectedBrowserAttestation()?.id" class="id">
                  {{formatId(selectedBrowserAttestation()?.id)}}
                </h3>
              </h3>
            }
            <app-details-browser-attestations
              [browserAttestation]="selectedBrowserAttestation()">
            </app-details-browser-attestations>
          </div>
        }
      </div>
    </div>
    }
  @else {
    @if (loadingOerror()) {
      <app-loading-error [boolean]="true" [message]="'waiting-for-browser-attestations' | translate"></app-loading-error>
    } @else {
      @if (!awaitChargementListe() && !loadingOerror() && searchmodel() && searchmodel() !== '') {
        <app-loading-error [boolean]="false"
          [search]="('component-error-search-attestation' | translate) + ' ' + searchmodel()"
          [order]="'component-attestation-search-order' | translate">
        </app-loading-error>
      } @else {
        @if (!awaitChargementListe() && !loadingOerror() && timestampToDate(filtersActive().from) !== timestampToDate(filtersActive().to)) {
          <app-loading-error [boolean]="false"
            [search]="('component-error-search-attestation' | translate) + ' ' + timestampToDate(filtersActive().from) + ' - ' + timestampToDate(filtersActive().to)"
            [order]="'component-error-filter-order' | translate">
          </app-loading-error>
        } @else {
          <app-loading-error [boolean]="false"
            [search]="('component-error-search-attestation' | translate) + ' ' + timestampToDate(filtersActive().from)"
            [order]="'component-error-filter-order' | translate">
          </app-loading-error>
        }
      }
    }
  }
  <app-toast-component></app-toast-component>